import React from 'react';
import { PresetData } from '../services/streaming-service';
import Loading from './Loading';

interface PresetsProps {
  categories: string[];
  selectedCategory: string;
  filteredPresets: PresetData[];
  selectedPreset: string;
  setSelectedCategory: (category: string) => void;
  setSelectedPreset: (preset: string) => void;
  isLoading?: boolean;
  error?: string | null;
}

const Presets: React.FC<PresetsProps> = ({
  categories,
  selectedCategory,
  filteredPresets,
  selectedPreset,
  setSelectedCategory,
  setSelectedPreset,
  isLoading = false,
  error = null
}) => {
  if (error) {
    return (
      <div className="presets-section">
        <h3>Presets</h3>
        <div className="error-message">
          <p>Error loading presets: {error}</p>
          <button onClick={() => window.location.reload()} className="retry-button">
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="presets-section">
      <h3>Presets</h3>

      {/* Category tabs */}
      <div className="category-tabs">
        {categories.map(category => (
          <button
            key={category}
            className={`tab-button ${category === selectedCategory ? 'active' : ''}`}
            onClick={() => setSelectedCategory(category)}
            disabled={isLoading}
          >
            {category}
          </button>
        ))}
      </div>

      {/* Preset buttons */}
      {isLoading ? (
        <Loading message="Loading presets..." size="small" />
      ) : (
        <div className="preset-buttons">
          {filteredPresets.map(preset => (
            <button
              key={preset.name}
              className={`preset-button ${preset.name === selectedPreset ? 'active' : ''}`}
              onClick={() => setSelectedPreset(preset.name)}
            >
              {preset.name}
            </button>
          ))}
        </div>
      )}

      <div className="presets-note">
        <p>
          Note: 
          Not all presets create a pattern, since some will cancel themselves out, or die out early, while others grow infinitely. <br/>
          Try and use center cross for some that don't automatically grow with just a center seed. Or look for the LeapOn variants for growing patterns. <br/>
          These presets are testing experiments to create various performance mechanisms for faster cell execution by leveraging x-ways symmetrical compression, creating optimization techniques and other mathematical combinations that enables computational efficiency to be used by various sciences.
        </p>
      </div>
    </div>
  );
};

export default Presets;
